import { ReactNode, useMemo } from 'react';
import { FieldFilterModeType } from '../../../utils/filterUtils';
import { calculateDisplayValue, calculateTooltipValue } from '../../FieldFilter.utils';
import { useFilterContext } from '../FilterContext';
import { FieldFilterValue, FilterOption } from '../types';

interface UseFieldFilterDisplayParams {
  filterObject: FieldFilterValue | undefined;
  mode: FieldFilterModeType;
  isDateField: boolean;
  valueOperator: string;
  value: unknown;
  operator: string;
  calcOptions: FilterOption[];
  conditionValue: FieldFilterValue;
  getValue: ((v: unknown) => ReactNode) | undefined;
}

export const useFieldFilterDisplay = ({
  filterObject,
  mode,
  isDateField,
  valueOperator,
  value,
  operator,
  calcOptions,
  conditionValue,
  getValue,
}: UseFieldFilterDisplayParams) => {
  const { measurements } = useFilterContext();
  const tooltipValue = useMemo(
    () =>
      calculateTooltipValue({
        filterObject,
        mode,
        isDateField,
        valueOperator,
        value,
        operator,
        calcOptions,
      }),
    [value, conditionValue, filterObject, operator, mode, isDateField, valueOperator, calcOptions]
  );

  const displayValue = useMemo(
    () =>
      calculateDisplayValue({
        filterObject,
        isDateField,
        valueOperator,
        value,
        getValue,
        calcOptions,
        measurementsAsObject: measurements.asObject,
      }),
    [value, conditionValue, filterObject, operator, getValue, isDateField, valueOperator, calcOptions, measurements.asObject]
  );

  return { tooltipValue, displayValue };
};
